import EntityList from "../../components/entities/EntityList";

const EntityPage = () => {
   return <EntityList />;
}

export default EntityPage;
